import {
  SelfServeSource,
  Strategy,
} from "@faire/help-center-self-serve/consts";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getIsLoggedInUser } from "@faire/help-center-utils/serialized-data/getUser";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Button, ButtonVariants } from "@faire/web--source/slate/Button";
import { ChatBubble } from "@faire/web--source/slate/icons/foundation/ChatBubble";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackCxFoundationsContactusbuttonClick } from "@faire/web-api--source/events/cxFoundations/click/contactusbutton";
import React from "react";
import styled from "styled-components";

import { useAIChatbotAccess } from "../hooks/useAIChatbotAccess";

interface IProps {
  className?: string;
  source?: SelfServeSource;
  variant?: ButtonVariants;
  style?: React.CSSProperties;
  iconDisabled?: boolean;
}

export const ContactUsButton: React.FC<IProps> = ({
  className,
  source,
  variant,
  style,
  iconDisabled,
}) => {
  const retailerToken = getRetailerToken();
  const brandToken = getBrandToken();
  const { isMobile } = useViewport();
  const { hasAIChatbotAccess } = useAIChatbotAccess();
  const isLoggedInUser = getIsLoggedInUser();

  const handleContactUsClick = () => {
    if (hasAIChatbotAccess) {
      trackCxFoundationsContactusbuttonClick(
        source ?? "",
        retailerToken ?? "",
        brandToken ?? "",
        Strategy.DECAGON
      );
      window.duet.open();
    } else {
      // old self-serve contact us button
      if (isLoggedInUser) {
        trackCxFoundationsContactusbuttonClick(
          source ?? "",
          retailerToken ?? "",
          brandToken ?? "",
          Strategy.SELF_SERVE
        );
      }
    }
  };

  return (
    <HelpButton
      style={style}
      variant={variant ?? "primary"}
      linkTo={
        hasAIChatbotAccess
          ? undefined
          : getCurrentPath().append({ contact: "true" }).toString()
      }
      onClick={handleContactUsClick}
      className={className}
      data-test-id="contact-us-button"
    >
      {isMobile || iconDisabled ? null : (
        <>
          <ChatBubble color="inherit" strokeWidth={2} />
          <Spacer width="1x" />
        </>
      )}

      <StrictLocalMsg
        defaultMessage="Contact us"
        description={{
          img: "https://cdn.faire.com/fastly/58499874ae013fe6e7aa381bd57cff9727209fe9acc0becd8f6a2a5907d6d759.png",
        }}
      />
    </HelpButton>
  );
};

const HelpButton = styled(Button)`
  padding: 10px 24px;
  white-space: nowrap;
`;
